import { render, staticRenderFns } from "./AddCategoryView.vue?vue&type=template&id=b03a2cdc"
import script from "./AddCategoryView.vue?vue&type=script&lang=js"
export * from "./AddCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports